import { authHttp } from '../http'
import * as routes from '../../routes/registration.routes'
import { errorHandler } from '../../../util/error.service'

export async function getZonasEntrega(tp_id) {
  try {
    const response = await authHttp().get(routes.urlGetZonasEntrega(tp_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function saveZonaEntrega(zonaEntrega) {
  try {
    const response = await authHttp().post(routes.urlPostZonaEntrega, zonaEntrega)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function updateZonaEntrega(zonaEntrega) {
  try {
    const response = await authHttp().put(routes.urlPutZonaEntrega(zonaEntrega.id), zonaEntrega)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
